import * as React from "react";
import { Permission, ControlType } from "~/client/resources";
import type { ActionTemplateParameterResource } from "~/client/resources/actionTemplateParameterResource";
import ActionTemplateParameterList from "~/components/ActionTemplateParametersList/ActionTemplateParametersList";
import { Section } from "~/components/Section/Section";

interface VariableSetTemplatesProps {
    parameters: ActionTemplateParameterResource[];
    onParametersChanged(parameters: ActionTemplateParameterResource[]): void;
}

export default class VariableSetTemplates extends React.Component<VariableSetTemplatesProps> {
    render() {
        return (
            <Section>
                <ActionTemplateParameterList
                    parameters={this.props.parameters}
                    name="template"
                    excludedControlTypes={[ControlType.StepName, ControlType.Package]}
                    editPermission={{
                        permission: Permission.VariableEdit,
                        wildcard: true,
                    }}
                    onParametersChanged={(parameters) => this.props.onParametersChanged(parameters)}
                />
            </Section>
        );
    }
}
